var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueTypeaheadBootstrap',{class:[_vm.stateClass],attrs:{"data":_vm.moedas,"serializer":(item) => item.text + ' (' + item.simbolo + ')',"placeholder":_vm.placeholder,"showOnFocus":true,"size":_vm.size},on:{"hit":function($event){_vm.input_value = $event}},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})
}
var staticRenderFns = []

export { render, staticRenderFns }